<template>
  <el-dialog
    title="添加商品"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    @open="opened"
    :append-to-body="inner"
    :close-on-click-modal="false"
  >
    <el-input
      placeholder="请输入件号或关键字搜索，同时搜索多个件号请用顿号（、）隔开"
      v-model="keyword"
      class="input-with-select"
      prefix-icon="el-icon-search"
      clearable
    ></el-input>
    <el-table
      v-if="items.length > 0"
      ref="multipleTable"
      @selection-change="handleItemSelectionChange"
      :data="items"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="name" label="件号/类型" width="160">
        <template slot-scope="scope">
          <div>
            {{ scope.row.part_number }}
          </div>
          <div>
            {{ scope.row.commodity_category.name }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="ph" label="PH" width="100"></el-table-column> -->
      <el-table-column prop="description" label="描述"></el-table-column>
      <el-table-column prop="price" label="定价" width="100">
        <template slot-scope="scope">{{ scope.row.price.toFixed(2) }}</template>
      </el-table-column>
    </el-table>
    <div class="text-info-12 mt-10" v-else>
      {{ keyword.length > 0 ? '未找到对应产品，或产品已被添加' : '' }}
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { commodityList } from '../service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
    deviceid: Number,
  },
  watch: {
    show() {
      this.visible = this.show
    },
    keyword: 'searchItems',
  },
  data() {
    return {
      keyword: '',
      visible: this.show,
      items: [],
      selectionTmp: [],
      submiting: false,
    }
  },
  created() {},
  methods: {
    async searchItems() {
      let items = []
      this.items = []
      if ((this.keyword && this.keyword.length > 0) || this.deviceid) {
        let res = await commodityList({
          page: 0,
          size: 10,
          // status: 1,
          part_number: this.keyword,
          customer_device_id: this.deviceid || 0,
        })

        if (res.code == 0) {
          items = res.data.list
        }
      }

      if (this.selection.length == 0) {
        this.items = items
      } else {
        this.items = items.filter((i) => {
          return !this.selection.some((j) => i.id == j.item_id)
        })
      }
    },
    handleItemSelectionChange(val) {
      this.selectionTmp = val.map((item) => {
        item.count = 1
        item.checked = true
        item.price = item.price ? item.price : 0
        return item
      })
    },
    submit() {
      this.visible = false
      this.$emit('selected', this.selectionTmp)
    },
    opened() {
      this.keyword = ''
      this.items = []
      // if (this.deviceid) {
      //   this.searchItems()
      // }
    },
  },
}
</script>